import { gql } from '@apollo/client';
import { LeaveSubtypeFragment } from './leave-subtype.fragment';
export const AddLeaveSubtype = gql `
    mutation AddLeaveSubtype($institutionSetId: InstitutionSetId!, $input: StaffLeaveSubTypeInput!) {
        staffhours {
            leaves {
                subtypes {
                    createV2(institutionSetId: $institutionSetId, input: $input) {
                        ...LeaveSubtypeFragment
                    }
                }
            }
        }
    }
    ${LeaveSubtypeFragment}
`;
